import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ProjectExpenseType } from "../../../types/ScientificModule";

const initialState: ProjectExpenseType = {
    id: "",
    description: "",
    idPhase: "",
    idProject: "",
    money: 0,
    status: false,
};

const projectExpensesSlice = createSlice({
    name: "projectExpenses",
    initialState,
    reducers: {
        setProjectExpensesData: (
            state,
            action: PayloadAction<ProjectExpenseType>
        ) => ({ ...state, ...action.payload }),
        resetProjectExpensesData: () => ({ ...initialState }),
    },
});

export const { setProjectExpensesData, resetProjectExpensesData } =
    projectExpensesSlice.actions;

export default projectExpensesSlice.reducer;
